<template>
    <el-scrollbar>
        <div class="view-modal window-scorll">
            <div class="vue-form">
                <vue-form :state="formstate" @submit.prevent="onSubmit">
                    <validate tag="label">
                        <span>Name *</span>
                        <el-input size="mini" v-model="model.name" required name="name" />
                        <field-messages name="name">
                            <div>Success!</div>
                            <div slot="required">Name is a required field</div>
                        </field-messages>
                    </validate>
                    <validate tag="label">
                        <span>Email</span>
                        <el-input v-model="model.email" size="mini" name="email" type="email" required />
                        <field-messages name="email">
                            <span>Success</span>
                            <div slot="required">Email is a required field</div>
                            <div slot="email">Email is not valid</div>
                        </field-messages>
                    </validate>
                    <button type="submit">Submit</button>
                </vue-form>
                <pre class="fs-12">{{ formstate }}</pre>
            </div>
        </div>
    </el-scrollbar>
</template>
<script>
    export default{
        data() {
            return {
                formstate: {},
                model: {
                  name: '',
                  email: ''
                }
            }
        },
        created(){
            this.$parent.routerLoading();


            console.log(this.$store)
            this.$store.commit('increment')
            console.log(this.$store.state.count)
            console.log(this.$store.getters.doneTodos)
            console.log(this.$store.getters.getTodoById(1))
            console.log(this.$store.dispatch('increment'))
        },
        methods: {
            onSubmit () {
                console.log(this.formstate)
              if(this.formstate.$invalid) {
                // alert user and exit early
                return;
              }
              // otherwise submit form
            }
        }
    }
</script>
<style></style>


// WEBPACK FOOTER //
// src/components/main-content/vue-form.vue